import { Col, Row, Tooltip } from 'antd';
import download from 'downloadjs';
import parser from 'html-react-parser';
import { useState } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { PiPencilSimpleBold } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { SETTINGS_PATH } from '..';
import Apis from '../../../../api';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import { RootState } from '../../../../store/rootReducer';
import BackDrop from '../../../common/BackDrop';
import InfoView from '../../../common/InfoView';
import { KYCDoc, ReviewsV2 } from '../../../login/redux/types';
import { InvestorStatus } from '../../../login/utils/Status';
import OnboardingHeading from '../../onboarding/components/OnboardingHeading';
import OnboardingCard from '../../onboarding/components/common/Card';
import OnboardingRightContainer from '../../onboarding/components/common/Container';
import NewKYCFlow, { ErrorOnMyInfo } from '../../onboarding/components/kyc';
import IndividualKYC, { DocTooltip } from '../../onboarding/components/kyc/Manual/IndividualKYC';
import SinpassForm from '../../onboarding/components/kyc/Signpass';
import InstitutionalKYC from './InstitutionalKYC';

export const Review = () => {
    const kycReviewV2 = useSelector((state: RootState) => state.user.investor?.kyc?.reviewsV2);
    const hipl = useSelector((state: RootState) => state.user.investor?.isHIPL);
    const HSPLReview = kycReviewV2?.find((r: ReviewsV2) => r.entity === 'HSPL');
    const HIPLReview = kycReviewV2?.find((r: ReviewsV2) => r.entity === 'HIPL');
    let kycReview = HSPLReview?.status === InvestorStatus.PendingKYCAdditionalDetails ? HSPLReview?.reviewAudits : [];
    if (hipl && HIPLReview?.status === InvestorStatus.PendingKYCAdditionalDetails) {
        kycReview = kycReview?.concat(HIPLReview?.reviewAudits || []);
    }
    if (!kycReview || !kycReview[0]) return <div />;
    //if (investorStatus !== InvestorStatus.PendingKYCAdditionalDetails) return <div />;
    const comment = kycReview[kycReview.length - 1].comment;
    return (
        <div className="bg-white mb-4 WorkSans px-6 py-4 border border-[#27AE60]">
            <div className="text-[#0F2240] WorkSans-Bold">Please act on below KYC Review Feedback:</div>
            <div className="font-bold !text-red-400 feedback_color">{parser(comment || '')}</div>
        </div>
    );
};

export const KYCInfo = () => {
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status?.kyc);
    if (
        investorStatus !== InvestorStatus.PendingKYCAdditionalDetails &&
        investorStatus === InvestorStatus.PendingKYCSubmission
    ) {
        return (
            <>
                <OnboardingHeading title="Qualification of KYC Status" infoText="kycInfo" />
            </>
        );
    }
    return <div />;
};

const KYC = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);
    const kycInfo = useSelector((state: RootState) => state.user.investor?.kyc);
    const selectedType = location.state as { selectedType: string } | undefined;

    if (investorType === 'Institutional' || investorType === 'Corporate Accredited') return <InstitutionalKYC />;

    if (selectedType && selectedType.selectedType === 'error') {
        return <ErrorOnMyInfo />;
    } else if (selectedType && selectedType.selectedType === 'Manual') {
        return (
            <OnboardingRightContainer>
                {kycInfo?.info?.type === 'Myinfo' ? (
                    <SinpassForm
                        isSetting={true}
                        onClickCancel={() => navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`)}
                    />
                ) : (
                    <IndividualKYC
                        isSetting={true}
                        onClickCancel={() => navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`)}
                    />
                )}
            </OnboardingRightContainer>
        );
    }

    return (
        <div>
            {kycInfo && kycInfo.info && kycInfo.info.address && kycInfo.info.identity && <KYCInfo />}
            {kycInfo && kycInfo.info && kycInfo.info.address && kycInfo.info.identity && <Review />}
            {(!kycInfo || !kycInfo.info || !kycInfo.info.address || !kycInfo.info.identity) && <NewKYCFlow />}
            {kycInfo && kycInfo.info && kycInfo.info.address && kycInfo.info.identity && <KYCReadView />}
        </div>
    );
};
export default KYC;

const KYCReadView = () => {
    const kycInfo = useSelector((state: RootState) => state.user.investor?.kyc?.info);
    const kycDocs = useSelector((state: RootState) => state.user.investor?.kyc?.docs);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status?.kyc);
    const disabled =
        investorStatus !== InvestorStatus.PendingKYCSubmission &&
        investorStatus !== InvestorStatus.PendingKYCAdditionalDetails;

    const [isEdit, setEdit] = useState(false);

    let identityDocs: KYCDoc[] = [],
        addressDocs: KYCDoc[] = [],
        wealthDocs: KYCDoc[] = [];

    if (kycDocs && kycDocs.length > 0) {
        identityDocs = kycDocs.filter((k) => k.type === 'Identity Proof');
        addressDocs = kycDocs.filter((k) => k.type === 'Address Proof');
        wealthDocs = kycDocs.filter((k) => k.type === 'Wealth Proof');
    }

    let keyValues = [
        {
            name: 'ID Type',
            value: kycInfo && kycInfo.identity && kycInfo.identity.identityType,
        },
        {
            name: 'Identity Number',
            value: kycInfo && kycInfo.identity && kycInfo.identity.identityNumber,
        },
        {
            name: 'Date Of Birth',
            value: kycInfo && kycInfo.dob,
        },
    ];
    if (kycInfo?.type === 'Myinfo') {
        keyValues = [
            {
                name: 'Legal Name',
                value: kycInfo && kycInfo.legalName,
            },
            {
                name: '',
                value: '',
            },
            ...keyValues,
            {
                name: 'Gender',
                value: kycInfo?.gender,
            },
            {
                name: 'Alias name',
                value: kycInfo?.aliasName,
            },
            {
                name: 'Hanyu Pinyin Name',
                value: kycInfo?.hanyuPinyinName,
            },
            {
                name: 'Hanyu Pinyin Alias Name',
                value: kycInfo?.hanyuPinyinAliasName,
            },
            {
                name: 'Married Name',
                value: kycInfo?.marriedName,
            },
            {
                name: 'Country/Place of Birth',
                value: kycInfo?.birthCountry,
            },
            {
                name: 'Singapore Residential Status',
                value: kycInfo && kycInfo.residentialStatus,
            },
            {
                name: 'Nationality',
                value: kycInfo && kycInfo.nationality,
            },
        ];
    } else {
        keyValues = [
            {
                name: 'Legal First Name',
                value: kycInfo && kycInfo.legalFirstName,
            },
            {
                name: 'Legal Last Name',
                value: kycInfo && kycInfo.legalLastName,
            },
            ...keyValues,
            {
                name: 'Singapore Residential Status',
                value: kycInfo && kycInfo.residentialStatus,
            },
            {
                name: 'Nationality',
                value: kycInfo && kycInfo.nationality,
            },
        ];
    }

    const contactValue = [
        {
            name: 'Address 1',
            value: kycInfo && kycInfo.address && kycInfo.address.address1,
        },
        {
            name: 'Address 2',
            value: kycInfo && kycInfo.address && kycInfo.address.address2,
        },
        {
            name: 'Postal Code',
            value: kycInfo && kycInfo.address && kycInfo.address.postalCode,
        },
        {
            name: 'Country',
            value: kycInfo && kycInfo.address && kycInfo.address.country,
        },
    ];

    if (isEdit) {
        return (
            <OnboardingRightContainer>
                {kycInfo?.type === 'Myinfo' ? (
                    <SinpassForm isSetting={true} onClickCancel={() => setEdit(false)} />
                ) : (
                    <IndividualKYC isSetting={true} onClickCancel={() => setEdit(false)} />
                )}
            </OnboardingRightContainer>
        );
    }

    return (
        <OnboardingCard>
            <div className="cursor-default w-full flex justify-between">
                <div className={`${disabled ? 'w-full' : 'w-11/12'}`}>
                    <p className="page_title_onboarding mb-4 text-[#13974B]">Personal Information</p>
                    <Row gutter={[16, 16]}>
                        {keyValues.map((kv, index) => (
                            <InfoView name={kv.name} value={kv.value} index={index} key={`${kv.name}_${index}`} />
                        ))}
                    </Row>
                    <p className="page_title_onboarding my-4 pt-8 text-[#13974B]">Address Information</p>
                    <Row gutter={[16, 16]}>
                        {contactValue.map((kv, index) => (
                            <InfoView name={kv.name} value={kv.value} index={index} key={`${kv.name}_${index}`} />
                        ))}
                    </Row>
                    {kycInfo?.type !== 'Myinfo' && (
                        <>
                            <p className="page_title_onboarding my-4 pt-8 text-[#13974B]">KYC Documents</p>
                            <Row gutter={[16, 32]}>
                                <DocReadView
                                    title="Proof of identity (Certified True Copy)"
                                    list={identityDocs}
                                    tooltip={DocTooltip.identityProof}
                                />
                                <DocReadView
                                    title="Proof of address (Certified True Copy)"
                                    list={addressDocs}
                                    tooltip={DocTooltip.adreesProof}
                                />
                                <DocReadView
                                    title="Proof of Income or Net Assets"
                                    list={wealthDocs}
                                    tooltip={DocTooltip.wealthProof}
                                />
                            </Row>
                        </>
                    )}
                    {kycInfo?.type === 'Myinfo' && (
                        <>
                            {!kycInfo.noa?.amount && (
                                <p className="page_title_onboarding my-4 pt-8 text-[#13974B]">KYC Documents</p>
                            )}
                            {kycInfo.noa?.amount ? (
                                <>
                                    <p className="page_title_onboarding my-4 pt-8 text-[#13974B]">
                                        Annual Income (Notice of Assessment)
                                    </p>
                                    <Row gutter={[16, 16]}>
                                        <InfoView
                                            index={111}
                                            name={'Year'}
                                            value={`${kycInfo.noa?.yearofAssessment}`}
                                        />
                                        <InfoView
                                            index={111}
                                            name={'Income'}
                                            value={`${kycInfo.noa?.amount.currency} ${kycInfo.noa?.amount.amountUpto2dp}`}
                                        />
                                    </Row>
                                </>
                            ) : (
                                <DocReadView
                                    title="Proof of Income or Net Assets"
                                    list={wealthDocs}
                                    tooltip={DocTooltip.wealthProof}
                                />
                            )}
                        </>
                    )}
                </div>
                {!disabled && (
                    <div
                        className="w-9 h-9 md:w-10 md:h-10 rounded-full  cursor-pointer flex justify-center items-center bg-[#F5F6FF]"
                        onClick={() => setEdit(true)}
                    >
                        <PiPencilSimpleBold className="text-xl md:text-2xl" color="#13974B" />
                    </div>
                )}
            </div>
        </OnboardingCard>
    );
};

type DocProps = {
    list: KYCDoc[];
    title: string;
    tooltip?: string[];
};

export const DocReadView: React.FC<DocProps> = ({ list, title, tooltip }) => {
    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const [loader, setLoader] = useState(false);

    const onDownload = (doc: KYCDoc) => {
        if (investorUUID) {
            setLoader(true);
            Apis.KYCDocumentDownload(investorUUID, doc.uuid)
                .then((res) => {
                    download(
                        new Blob([res.data], { type: res.headers['content-type'] }),
                        doc.title,
                        res.headers['content-type'],
                    );
                })
                .finally(() => {
                    setLoader(false);
                });
        }
    };
    return (
        <>
            {loader && <BackDrop />}
            <Col xs={24} md={12}>
                <p style={{ color: 'rgb(110, 128, 157)' }} className="text-sm WorkSans">
                    {title}
                    {tooltip && (
                        <Tooltip
                            title={
                                <>
                                    {tooltip.map((t) => (
                                        <span key={t.substring(0, 10)}>
                                            {t} <br />
                                        </span>
                                    ))}
                                </>
                            }
                        >
                            <span className="ml-1 mr-4 inline-block relative top-0.5 color-182D4F">
                                <BsInfoCircle />
                            </span>
                        </Tooltip>
                    )}
                </p>
                {list.map((i, index) => (
                    <div key={`${title}_${i.title}_${index}`} className="flex items-center py-1">
                        <p
                            className="cursor-pointer hover:underline text-color-404040 WorkSans"
                            onClick={() => onDownload(i)}
                        >
                            {i.title}
                        </p>
                    </div>
                ))}
            </Col>
        </>
    );
};
